import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

export default class StaticBlock extends PureDataComponent {
  static propTypes = {
    element: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    content: PropTypes.string
  }

  render() {
    const { element, content, className, ...otherProps } = this.props
    return (
      <div
        className={classNames('rfd-ui-static-block', className)}
        dangerouslySetInnerHTML={{
          __html:
            null != content
              ? content
              : (() => {
                  if ('string' == typeof element) {
                    const foundElement = document.querySelector(element)
                    if (foundElement) return foundElement.innerHTML
                  } else if ('object' == typeof element && null != element.innerHTML) {
                    return element.innerHTML
                  }
                  return ''
                })()
        }}
        {...otherProps}
      />
    )
  }
}
